// removed by extract-text-webpack-plugin
module.exports = {"event-review-list-item":"_3KKKv21za _2SKVr1fPM _2piomsVWh _2l0xl0HVf _1gaUFCwDT _2F0aAUJAA","wrapper":"_2Xuv9-t9t _2l0xl0HVf _18QA6WPGs _2HOZDFp6P _1q8xxondo _3vQ8WWnW6 _2WOtyNnnu _2In90_LkW JTojnd7_C _3Fr_Alfko _25Tc0xLRM _1XwEUpgHW jfvXV0Ru5 _1Cfm0wUIj _2mpyhxotR _17ICTiffE","title":"_2rZs7yHEp _2l0xl0HVf _2AKkwhco3 _1lCmGBorg _1B4qcaoCi iNGToVUbh _23s7Mrdy_ _3X0ob54cP","action-wrapper":"_3gXnBbzWo _3PpvO3E_E","action":"_1NmGWpbaS _2l0xl0HVf _2E9qGyV4u _2piomsVWh _3cWZ9MSKx _1C3le7ltj OSBVy-e59 _3BiTzCAU- _3uKzqKb8t Q5jr4ygU0 _1bU7cv22t _3VLDjh4Zx _1-SdlAGAO _2AxoM5mzK ZJzW3NgDp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/event-review-list-item/event-review-list-item.css
 ** module id = 2109
 ** module chunks = 0
 **/